import comp from "./AIPanelSendButton";
export default comp;
